import { useState, useEffect } from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Legend,
} from "recharts";
import axios from "axios";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";

const Bandwidth_Consumption = () => {
    const { token } = isAutheticated();

    const [chartData, setChartData] = useState([]);
    const [filter, setFilter] = useState("monthly");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const res = await axios.get(
                    `${API}/api/bandwidthWithwatchTime/video/bandwidth?type=${filter}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                // ✅ IMPORTANT FIX
                setChartData(res.data.data);
            } catch (err) {
                setError("Failed to fetch bandwidth data");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [filter, token]);

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <h2>Video Bandwidth Consumption ({filter})</h2>

                    <div style={{ marginBottom: "15px" }}>
                        <button
                            onClick={() => setFilter("daily")}
                            style={{
                                backgroundColor: filter === "daily" ? "#007bff" : "#ccc",
                                color: filter === "daily" ? "#fff" : "#000",
                                padding: "8px 16px",
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            Daily
                        </button>

                        <button
                            onClick={() => setFilter("monthly")}
                            style={{
                                backgroundColor: filter === "monthly" ? "#007bff" : "#ccc",
                                color: filter === "monthly" ? "#fff" : "#000",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                            }}
                        >
                            Monthly
                        </button>
                    </div>

                    {loading && <p>Loading...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}

                    {!loading && !error && (
                        <LineChart width={900} height={350} data={chartData}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis
                                label={{
                                    value: "Bandwidth (MB)",
                                    angle: -90,
                                    position: "insideLeft",
                                }}
                            />
                            <Tooltip
                                formatter={(value) => [`${value.toFixed(2)} MB`, "Bandwidth"]}
                            />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="totalBandwidthMB"
                                stroke="#8884d8"
                                name="Total Bandwidth (MB)"
                            />
                        </LineChart>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Bandwidth_Consumption;
